import type { MessengerAlert, MessengerAlertCreationData } from '@widgets/messenger/types/alert'
import { defineStore } from '@/composition/defineStore'
import { ref } from '@/composition/vue/compositionApi'
import { getUuid } from '@/utils/uuid'

export const useWidgetAlertStore = defineStore(Symbol('widgetAlertStore'), () => {
  const alerts = ref<MessengerAlert[]>([])

  const addAlert = (data: MessengerAlertCreationData) => {
    // To prevent duplicate alerts
    if (data.id) {
      removeAlert(data.id)
    }

    const id = data.id ?? getUuid()
    const alert = {
      id,
      payload: {},
      ...data,
    }
    alerts.value.push(alert)
    return id
  }

  const removeAlert = (id: string) => {
    alerts.value = alerts.value.filter((alert) => alert.id !== id)
  }

  const removeAlertBy = (predicate: (alert: MessengerAlert) => boolean) => {
    alerts.value = alerts.value.filter((alert) => !predicate(alert))
  }

  return {
    alerts,
    addAlert,
    removeAlert,
    removeAlertBy,
  }
})
